// A neutral stand-in brand mark, shared by the white-label demo page and the dev mock fixtures.
//
// Both used to point at real logos committed under src/mocks (a third party's trademark among
// them), which have no business in this repo. This is deliberately generic: a white tile with a
// connectivity glyph, legible on any accent colour the header might be painted with, inlined as
// a data URI so there is no asset request and nothing to check in.
//
// SVG attributes are single-quoted so the TS strings can stay double-quoted (eslint `quotes`).

const PLACEHOLDER_LOGO_SVG = [
    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'>",
    "<rect width='32' height='32' rx='9' fill='#FFFFFF'/>",
    "<circle cx='16' cy='22.6' r='2.2' fill='#0F172A'/>",
    "<path d='M11.4 18.4a6.5 6.5 0 0 1 9.2 0' stroke='#0F172A' stroke-width='2.4' fill='none' stroke-linecap='round'/>",
    "<path d='M7.8 14.4a11.6 11.6 0 0 1 16.4 0' stroke='#0F172A' stroke-width='2.4' fill='none' stroke-linecap='round'/>",
    "</svg>"
].join("");

export const PLACEHOLDER_LOGO_URL = `data:image/svg+xml,${encodeURIComponent(PLACEHOLDER_LOGO_SVG)}`;
